import { camelCase, debounce, isFromBreakpoint } from '@theme/helpers';
import { HTMLCustomElement } from '@theme/html-custom-element';

class ResponsiveMedia extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.on(
      'resize',
      window,
      debounce(() => this.handleResize()),
    );

    /**
     * Set the default state on load.
     */
    this.handleResize();
  }

  /**
   * Handles the resize event.
   */
  handleResize() {
    if (isFromBreakpoint('large') && this.refs.largeTemplate) {
      if (!(this.current === 'large')) {
        this.setOutput('large');
      }

      return;
    }

    if (this.refs.defaultTemplate && !(this.current === 'default')) {
      this.setOutput('default');
    }
  }

  /**
   * Sets the output for the given breakpoint type.
   * @param {'default' | 'large'} type - The breakpoint type.
   */
  setOutput(type) {
    this.refs.output.innerHTML = '';
    this.refs.output.appendChild(this.refs[`${camelCase(type)}Template`].content.cloneNode(true));
    this.current = type;
  }
}

if (!customElements.get('responsive-media')) customElements.define('responsive-media', ResponsiveMedia);
